"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBar = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Color_1 = require("../../styles/Color");
const styles_1 = require("@material-ui/core/styles");
const { GREEN_LIGHT, GREEN_TREEZ } = Color_1.ColorName;
const GreenLinearProgress = core_1.withStyles({
    root: {
        backgroundColor: styles_1.lighten(Color_1.Color[GREEN_LIGHT], .5),
    },
    barColorPrimary: {
        backgroundColor: Color_1.Color[GREEN_TREEZ],
    },
})(core_1.LinearProgress);
exports.LoadingBar = () => {
    return (react_1.default.createElement("div", { className: 'treez-loader-bar-container' },
        react_1.default.createElement(GreenLinearProgress, { className: 'treez-loader-bar' })));
};
exports.default = exports.LoadingBar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9hZGluZ0Jhci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mZWVkYmFjay9sb2FkaW5nL0xvYWRpbmdCYXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUFxRDtBQUNyRCw0Q0FHaUU7QUFDakUsOENBR2tFO0FBQ2xFLHFEQUF3RTtBQUV4RSxNQUFNLEVBQ0YsV0FBVyxFQUNYLFdBQVcsRUFDZCxHQUFHLGlCQUFTLENBQUM7QUFFZCxNQUFNLG1CQUFtQixHQUFHLGlCQUFVLENBQUM7SUFDbkMsSUFBSSxFQUFFO1FBQ0YsZUFBZSxFQUFFLGdCQUFPLENBQUMsYUFBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLEVBQUUsQ0FBQztLQUNuRDtJQUNELGVBQWUsRUFBRTtRQUNiLGVBQWUsRUFBRSxhQUFLLENBQUMsV0FBVyxDQUFDO0tBQ3RDO0NBQ0osQ0FBQyxDQUFDLHFCQUFjLENBQUMsQ0FBQztBQUVOLFFBQUEsVUFBVSxHQUFHLEdBQUcsRUFBRTtJQUMzQixPQUFPLENBQ0gsdUNBQUssU0FBUyxFQUFHLDRCQUE0QjtRQUN6Qyw4QkFBQyxtQkFBbUIsSUFBQyxTQUFTLEVBQUcsa0JBQWtCLEdBQUUsQ0FDbkQsQ0FDVCxDQUFBO0FBQ0wsQ0FBQyxDQUFBO0FBRUQsa0JBQWUsa0JBQVUsQ0FBQyJ9